var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75269 2.2296L4.4998 10.1657C4.52566 10.2404 4.5745 10.3051 4.63931 10.3504C4.70413 10.3957 4.78161 10.4193 4.86068 10.418C4.93975 10.4166 5.01636 10.3903 5.07957 10.3427C5.14277 10.2952 5.18933 10.2289 5.21258 10.1533L6.31675 6.56477C6.33474 6.50631 6.36675 6.45313 6.41 6.40988C6.45325 6.36663 6.50643 6.33462 6.56489 6.31663L10.1534 5.21246C10.229 5.1892 10.2953 5.14265 10.3429 5.07944C10.3904 5.01624 10.4167 4.93963 10.4181 4.86056C10.4195 4.78149 10.3958 4.70401 10.3505 4.63919C10.3052 4.57438 10.2406 4.52554 10.1658 4.49968L2.22972 1.75256C2.16322 1.72954 2.09158 1.7257 2.023 1.74148C1.95441 1.75725 1.89165 1.79201 1.84189 1.84177C1.79213 1.89153 1.75737 1.95429 1.7416 2.02288C1.72582 2.09146 1.72967 2.1631 1.75269 2.2296Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrow);
export default __webpack_public_path__ + "static/media/navigationArrow.afb41ac941de42feb71492b7a54da27c.svg";
export { ForwardRef as ReactComponent };